import clsx from 'clsx'
import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { PageLink, PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import Checkbox from '@material-ui/core/Checkbox';
import { useParams } from 'react-router-dom';
import { Formatter, pegarEmpresaSelecionada, Periodo, Tipo } from "./Relatorio";
import RelatoriosService from '../../services/RelatoriosService';
import { IDetalhesPendente } from '../../interfaces/IRelatorio';

interface Column {
  id: string;
  label: string;
  width?: string;
  align?: 'left' | 'center' | 'right'
}

function RelatorioPendentes() {

  const { classes } = useLayout();
  const { id } = useParams<{ id: string }>();
  const [carregado, setCarregado] = useState<boolean>(false);
  const [dataInicial, setDataInicial] = useState<Date>();
  const [dataFinal, setDataFinal] = useState<Date>();
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [selecionados, setSelecionados] = useState<string[]>([]);
  const [todosMarcados, setTodosMarcados] = useState<boolean>(false);
  const [detalhesPendentes, setDetalhesPendentes] = useState<IDetalhesPendente[]>([]);
  const [dadosExportar, setDadosExportar] = useState<any>();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Clientes',
      path: '/relatorioSelecionarCliente',
      isSeparator: false,
      isActive: false
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false
    },
    {
      title: 'Relatório',
      path: `/relatorio/${id}`,
      isSeparator: false,
      isActive: false
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: true
    }
  ];
  const columns: Column[] = [
    { id: 'origem', label: 'Origem ECD', width: '12%', align: 'center' },
    { id: 'contaEmpresa', label: 'Conta Empresa', width: '8%', align: 'center' },
    { id: 'contaRef', label: 'Conta Ref.', width: '10%', align: 'center' },
    { id: 'descricaoEmpresa', label: 'Descrição C. Contábil', width: '16%', align: 'center' },
    { id: 'dataString', label: 'Data', width: '10%', align: 'center' },
    { id: 'valor', label: 'Valor', width: '6%', align: 'center' },
    { id: 'tipoLancamento', label: 'Lançamento', width: '6%', align: 'center' },
    { id: 'historico', label: 'Histórico', width: '16%', align: 'center' },
    { id: 'simbolo', label: 'Símbolo', width: '6%', align: 'center' },
    { id: 'erro', label: 'Erro', width: '15%', align: 'center' },
    { id: 'recomendacao', label: 'Recomendação', width: '15%', align: 'center' },
  ];
  const useStyles = makeStyles({
    root: {
      width: '100%'
    },
    container: {
      maxHeight: 600
    },
    cell: {
      fontSize: '0.750em',
      padding: '0.250em',
      height: '42px'
    },
    simbolo: {
      '& *': {
        color:'#00B757',
        fontSize: '1.5rem'
      }
    }
  });
  const styles = useStyles();

  useEffect(() => {
    function preCarregar() {
      try {
        const titulo = document.querySelectorAll("h1")[0];
        const estilo = titulo.getAttribute('style') + 'font-size: 14px';
        const pageTitle = document.querySelectorAll(".page-title")[0];
        const estiloPageTitle = (pageTitle.getAttribute('style') ?? "") + 'margin-right: 0 !important';

        titulo.setAttribute('style', estilo);
        pageTitle.setAttribute('style', estiloPageTitle);
      } catch {
        setTimeout(() => {
          preCarregar();
        }, 50);
      }
    }

    const jsonDataInicial = localStorage.getItem(`${Tipo.DataInicial}`) as "";
    const dataInicial = JSON.parse(jsonDataInicial) as Date | undefined;
    const jsonDataFinal = localStorage.getItem(`${Tipo.DataFinal}`) as "";
    const dataFinal = JSON.parse(jsonDataFinal) as Date | undefined;

    setDataInicial(dataInicial);
    setDataFinal(dataFinal);

    preCarregar();
  }, [])

  useEffect(() => {
    localStorage.setItem(`${Tipo.DataInicial}`, JSON.stringify(dataInicial));
  }, [dataInicial])

  useEffect(() => {
    localStorage.setItem(`${Tipo.DataFinal}`, JSON.stringify(dataFinal));
  }, [dataFinal])

  useEffect(() => {
    async function preCarregar() {
      setCarregado(false);

      const empresa = pegarEmpresaSelecionada();
      const jsonContaEmpresa = localStorage.getItem(`${Tipo.ContaEmpresa}`) as "";
      const contaEmpresa = JSON.parse(jsonContaEmpresa) as number | undefined;

      if (empresa && empresa.id !== 0 && dataInicial && dataFinal) {
        await RelatoriosService.detalhesPendentes(empresa.id, jsonContaEmpresa, dataInicial, dataFinal, x => {
          let pendentes = x.filter(p => !contaEmpresa || p.contaEmpresa === contaEmpresa.toString());
          setDetalhesPendentes(pendentes);
          setDadosExportar(pendentes.map(p => {
            let pendente = {
              'Origem ECD': p.origem,
              'Descricão Empresa': p.descricaoEmpresa,
              'Data': p.dataString,
              'Valor': p.valor,
              'Lançamento': p.tipoLancamento,
              'Histórico': p.historico,
            };

            return pendente;
          }));
        });
      }

      setCarregado(true);
    }

    setTimeout(() => {
      preCarregar();
    }, 1000);
  }, [id, dataInicial, dataFinal])

  useEffect(() => {
    setSelecionados([]);
  }, [page]);

  useEffect(() => {
    setTodosMarcados(selecionados.length === (page * rowsPerPage + rowsPerPage) - (page * rowsPerPage));
    localStorage.setItem(`${Tipo.ListaContasEmpresa}`, JSON.stringify(selecionados));

    //eslint-disable-next-line
  }, [selecionados]);

  async function trocarTodosValores(valor: boolean) {
    if (valor) {
      const listaIds = detalhesPendentes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(x => x.id.toString());

      setSelecionados(listaIds);
    }
    else {
      setSelecionados([]);
    }
  }

  async function trocarValor(id: string, valor: boolean) {
    if (valor) {
      setSelecionados([...selecionados, id]);
    }
    else {
      setSelecionados(selecionados.filter(x => x !== id));
    }
  }

  function handleChangePage(event: unknown, newPage: number) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }

  function acaoBotaoPeriodo(dataInicial: Date | undefined, dataFinal: Date | undefined) {
    setDataInicial(dataInicial);
    setDataFinal(dataFinal);
  }

  return <>
    <PageTitle pageBack={`/relatorio/${id}`} breadcrumbs={breadCrumbs}>{localStorage.getItem(`${Tipo.Pendente}`)}</PageTitle>
    <label style={{ color: '#525252', fontWeight: 700, fontSize: '20px', marginBottom: '10px' }}>{dataInicial && dataFinal ? carregado ? detalhesPendentes.length ? `Pendências encontradas (${detalhesPendentes.length})` : 'Não foi encontrado nenhuma Pendência para ser exibida' : 'Carregando...' : 'Preencha o campo Período e clique em buscar para carregar os dados'}</label>
    <div className='toolbar' id='kt_toolbar' style={{ padding: ' 0 10px' }}>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex')} style={{ padding: '0' }}>
        <DefaultTitle />
        <Periodo dadosExportar={dadosExportar} dataInicio={dataInicial} dataFim={dataFinal} acaoBotaoBuscar={acaoBotaoPeriodo} empresaId={parseInt(id)} />
      </div>
    </div>

    {
      dataInicial && dataFinal && carregado && detalhesPendentes.length > 0 &&
      <>
        <Paper className={styles.root} style={{ outline: '1px solid #A3A3A3', padding: '0 2px' }}>
          <TableContainer className={styles.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow style={{ outline: '1px solid #A3A3A3', backgroundColor: '#ffffff', userSelect: 'none' }}>
                  <TableCell padding="checkbox" className={styles.cell} style={{ backgroundColor: '#ffffff' }}>
                    <Checkbox checked={todosMarcados} onChange={e => trocarTodosValores(e.target.checked)} />
                  </TableCell>
                  {
                    columns.map((column, index) =>
                      <TableCell key={index} align={column.align} className={styles.cell} style={{ width: column.width, color: '#5E6397', fontWeight: 700, backgroundColor: '#ffffff' }} >
                        {column.label}
                      </TableCell>)
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  detalhesPendentes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) =>
                    <TableRow hover role="checkbox" tabIndex={-1} key={index} style={{ padding: 'none', outline: '1px solid #A3A3A3' }}>
                      <TableCell padding="checkbox" className={styles.cell}>
                        <Checkbox onChange={e => trocarValor(row.id.toString(), e.target.checked)} checked={selecionados.find(x => x === row.id.toString()) !== undefined} inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${row.id}` }} />
                      </TableCell>
                      {
                        columns.map((column, index) =>
                          <TableCell key={index} align={column.align} className={styles.cell} style={{ width: column.width }}>
                            { 
                              column.id === 'simbolo' ? 
                                <div className={styles.simbolo} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(row.simbolo) }} />
                              :
                                column.id === 'valor' ?
                                  Formatter.format(row['valor'])
                                  :
                                  row[column.id as keyof IDetalhesPendente]
                            }
                          </TableCell>)
                      }
                    </TableRow>)
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <TablePagination rowsPerPageOptions={[]} component="div" count={detalhesPendentes.length} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
      </>
    }
  </>
};

export default RelatorioPendentes;